import { render, staticRenderFns } from "./UploadID.vue?vue&type=template&id=6cebbf4c"
import script from "./UploadID.vue?vue&type=script&lang=js"
export * from "./UploadID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports